<template>
	<main class="complete">
		<div class="icon_wrapper">
			<img src="@/assets/img/common/complete.png" alt="구독 결제 완료 아이콘" loading="lazy" />
			<div class="icon_title">
				<p>결제가 완료되었습니다!</p>
			</div>
		</div>
		<div class="c_fieldArea">
			<button class="c_button radius-x-small primary-fill save" @click="$router.replace('/notice-detail/188')">
				이용방법 보러가기
			</button>
			<button class="c_button radius-x-small mid save" @click="handleMoveHome">홈으로 가기</button>
		</div>
	</main>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const handleMoveHome = () => {
	router.replace('/');
};
</script>
<style lang="scss" scoped>
.complete {
	padding-top: var(--header-height);
	display: flex;
	flex-direction: column;
	gap: var(--space-xx-large);
	max-width: 40rem;
	margin: 0 auto;
	justify-content: center;
	width: 100%;
	img {
		width: 12rem;
	}
	@media screen and (max-width: 1280px) {
		padding: 0rem 2rem 0rem 2rem;
	}
	.icon_wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-large);
		.icon_title {
			font-weight: var(--font-w-semi-bold);
			font-size: var(--space-large);
			line-height: 2.387rem;
		}
	}
	.c_fieldArea {
		gap: var(--space-mid);
		button {
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			height: 4.8rem;
		}
	}
}
</style>
